import * as React from 'react';

const Logo = ({ url , className , image , title , srOnlyText  })=>/*#__PURE__*/ React.createElement("a", {
        className: `logo ${className || ''}`,
        href: url,
        title: title,
        "data-t": "logo-link"
    }, /*#__PURE__*/ React.createElement("img", {
        className: "logo__img",
        src: image.url,
        alt: title,
        "data-t": "logo-image"
    }), srOnlyText && /*#__PURE__*/ React.createElement("span", {
        className: "sr-only",
        "data-t": "logo-sr-only"
    }, srOnlyText))
;

export { Logo as default };
//# sourceMappingURL=Logo.js.map
